import { Button, ButtonGroup, FormLabel, ModalBody, ModalFooter, Radio, RadioGroup, SelectionControlLabel, TextField, Typography, } from '@one-thd/sui-atomic-components';
import React, { useState } from 'react';
import { quickbooksDesktopExport } from '../../../../api/oms/order-history';
import { pushErrorEvent } from '../../../../utils/analytics';
import { createTimeStamp } from '../../../../utils/date-utils';
import { openFile, parseBlob } from '../../../../utils/http-helper';
import { pushQuickBookExportEvent } from '../../../../utils/purchase-history/analytics';
var saveQBFile = function (data, fileName) {
    var blob = parseBlob(data, 'data:application/iif');
    return openFile(blob, fileName);
};
var handleSuccessDesktopRequest = function (response, setOpenModal, setAlertState, fileName) {
    var msg = "Purchase History Data successfully exported. \n    Please check your downloads folder for the file.";
    setAlertState({ status: 'success', alertMessage: msg });
    saveQBFile(response.data, "".concat(fileName, ".iif"));
    setOpenModal(false);
};
var handleFailureOnlineRequest = function (error, setAlertState, setOpenModal) {
    pushErrorEvent('purchase history quickbooks desktop export', error.code || '', error.message, 'inline');
    setAlertState({
        status: 'error',
        alertMessage: 'We ran into a problem, please try again.',
    });
    setOpenModal(false);
};
var handleOnlineExportClick = function (request, qbExportValue, setOpenModal, setAlertState, fileName) {
    var updatedRequest = request;
    if (qbExportValue === 'details') {
        updatedRequest.includeDetails = true;
    }
    var wrappedRequest = { orderHistoryRequest: updatedRequest };
    pushQuickBookExportEvent("purchase history: quickbooks export desktop ".concat(qbExportValue));
    quickbooksDesktopExport(wrappedRequest)
        .then(function (response) {
        handleSuccessDesktopRequest(response, setOpenModal, setAlertState, fileName);
    })
        .catch(function (error) {
        handleFailureOnlineRequest(error, setAlertState, setOpenModal);
    });
};
var QuickBooksDesktopExport = function (_a) {
    var setQBRenderFlag = _a.setQBRenderFlag, request = _a.request, setOpenModal = _a.setOpenModal, setAlertState = _a.setAlertState;
    var _b = useState(), radioValue = _b[0], setRadioValue = _b[1];
    var _c = useState("Purchase_History_".concat(createTimeStamp())), fileName = _c[0], setFileName = _c[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalBody, null,
            React.createElement(React.Fragment, null,
                React.createElement(FormLabel, { id: "online-qb-export-radio-buttons-group-label" }, "Select data to export:"),
                React.createElement(RadioGroup, { "aria-labelledby": "online-qb-export-radio-buttons-group-label", name: "online-qb-export-radio-buttons-group", value: radioValue, onChange: function (event) {
                        setRadioValue(event.target.value);
                    } },
                    React.createElement(SelectionControlLabel, { value: "summary", label: "Summary Data" },
                        React.createElement(Radio, null)),
                    React.createElement(SelectionControlLabel, { value: "details", label: "Details Data" },
                        React.createElement(Radio, null)))),
            React.createElement("div", { className: "sui-py-1" },
                React.createElement(Typography, null, "Data will be exported as an iif file.")),
            React.createElement(TextField, { required: true, fullWidth: true, label: "Filename", placeholder: "Default File Name", statusMessage: fileName === '' ? 'Filename is required' : undefined, status: fileName === '' ? 'error' : undefined, value: fileName, onChange: function (event) {
                    setFileName(event.target.value);
                } })),
        React.createElement(ModalFooter, { position: "end" },
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { onClick: function () {
                        setQBRenderFlag(undefined);
                    } }, "Go Back"),
                React.createElement(Button, { disabled: radioValue === undefined && (fileName !== '' || undefined), onClick: function () {
                        return handleOnlineExportClick(request, radioValue, setOpenModal, setAlertState, fileName);
                    } }, "Submit")))));
};
export default QuickBooksDesktopExport;
